import styled, { css } from 'styled-components';

import {
    Anchor, Button, Heading, Text,
} from '@zillow/constellation';

import WizardActionFooter from 'app/shared/components/WizardActionFooter';

export const StyledAnchor = styled(Anchor)`
    font-weight: 600;
`;

export const StyledFadeInButton = styled(Button)`
    animation: fadeIn ease 2s;
    align-self: center;

    @keyframes fadeIn {
        0% {
            opacity:0;
        }
        100% {
            opacity:1;
        }
    }
`;

export const StyledFadeInHeading = styled(Heading)`
    animation: fadeIn ease 2s;

    @keyframes fadeIn {
        0% {
            opacity:0;
        }
        100% {
            opacity:1;
        }
    }
`;

export const StyledFadeInText = styled(Text)`
    animation: fadeIn ease 2s;

    @keyframes fadeIn {
        0% {
            opacity:0;
        }
        100% {
            opacity:1;
        }
    }
`;

export const StyledWizardActionFooter = styled(WizardActionFooter)`
    ${props => props.nextLabel === 'Go to properties' && css`
        .nextButton {
            animation: fadeIn ease 2s;
        }
    `}

    ${props => props.hideNextButton && css`
        .nextButton {
            animation: fadeOut ease 2s;
        }
    `}

    @keyframes fadeIn {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

    @keyframes fadeOut {
        0% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }
`;
